import React from 'react';
import './ErrorBoundary.css';

interface ChartErrorFallbackProps {
  error: Error | null;
  onRetry: () => void;
}

const ChartErrorFallback: React.FC<ChartErrorFallbackProps> = ({ error, onRetry }) => {
  return (
    <div className="error-boundary-fallback chart-error-fallback">
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        <line x1="12" y1="12" x2="12" y2="12.01" strokeLinecap="round" />
      </svg>
      <h3>Chart Failed to Load</h3>
      <p>{error?.message || 'An unexpected error occurred while rendering the chart.'}</p>
      <button onClick={onRetry}>Reload Chart</button>
    </div>
  );
};

export default ChartErrorFallback;
